var els = $('[data-complete-reservation]');
if (els.length > 0) {
  require.ensure('../controllers/complete_reservation_controller', function(
    require
  ) {
    var CompleteReservationController = require('../controllers/complete_reservation_controller');
    els.each(function() {
      return new CompleteReservationController(this);
    });
  });
}



// WEBPACK FOOTER //
// ./src/javascripts/platform/initializers/complete_reservation.initializer.js